<div class="p-menu-wrapper">
  <button type="button" pButton [icon]="icon" [label]="label" (click)="menu.toggle($event)"></button>
  <p-menu #menu [model]="items" [popup]="true" appendTo="body" styleClass="dropdown-menu"></p-menu>
</div>
